import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
`;

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 12000;
  padding: 1rem;
`;

export const ModalContent = styled.div`
  background-color: ${(props) => props.theme.colors?.backgroundColor || '#ffffff'};
  color: ${(props) => props.theme.colors?.text?.primary || '#111827'};
  border-radius: 16px;
  padding: 2rem 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  border: 1px solid ${(props) => props.theme.colors?.gray02 || '#e5e7eb'};
  width: 100%;
  max-width: 420px;
  animation: ${slideUp} 0.3s ease-out;
  transition: all 0.2s ease;

  @media (max-width: 768px) {
    padding: 1.5rem 1.25rem 1.25rem;
    max-width: 90%;
    border-radius: 16px;
  }
`;

export const IconWrapper = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: linear-gradient(
    135deg,
    ${(props) => (props.theme.colors?.danger || '#ef4444')}15 0%,
    ${(props) => (props.theme.colors?.danger || '#ef4444')}08 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  border: 2px solid ${(props) => (props.theme.colors?.danger || '#ef4444')}30;
  animation: ${pulse} 2s ease-in-out infinite;
  color: ${(props) => props.theme.colors?.danger || '#ef4444'};

  @media (max-width: 768px) {
    width: 64px;
    height: 64px;
    margin-bottom: 1.25rem;
  }
`;

export const Message = styled.p`
  margin: 0 0 2rem;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs16};
  font-weight: 500;
  line-height: 1.6;
  color: ${(props) => props.theme.colors?.text?.primary || '#111827'};
  max-width: 100%;
  white-space: pre-line;

  @media (max-width: 768px) {
    font-size: 0.875rem;
    margin-bottom: 1.5rem;
    line-height: 1.5;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.625rem;

    button {
      width: 100%;
    }
  }
`;

